<script setup lang="ts">
import { ref } from 'vue'
import { useNetwork } from '../composables/useNetwork'

interface BannerOfflineProps {
  /** For logging */
  // dataTest: string
  /** Quasar color, any other overrides */
  classProps?: string
}
const props = withDefaults(defineProps<BannerOfflineProps>(), {
  classProps: 'bg-warning',
})

const { getStatus } = useNetwork()

const bannerRef = ref()
</script>
<template>
  <q-banner
    inline-actions
    class="text-black bg-warning q-mb-md"
    v-if="!getStatus"
    ref="bannerRef"
    v-bind="props"
  >
    <slot />
  </q-banner>
</template>
